import { STAGE_LABELS, type WorkflowStageId } from "../intakeDetails/types";
import { statusOptions } from "../projectDetails/types";

/**
 * Canonical workflow stage order (mirrors components/workflow/StageStepper.tsx)
 * with `completed` appended so finished intakes also live on the board.
 */
export const STAGE_ORDER: WorkflowStageId[] = [
  "schedule_meeting",
  "scoring_chart",
  "vendor_matching",
  "ai_advisory_board_presentation",
  "leadership_presentation",
  "approval_decision",
  "completed",
];

export interface IntakeColumn {
  /** Stable column id (also the WorkflowStageId for intakes). */
  id: WorkflowStageId;
  /** Display label rendered in the column header. */
  label: string;
}

export const INTAKE_COLUMNS: IntakeColumn[] = STAGE_ORDER.map((stage) => ({
  id: stage,
  label: STAGE_LABELS[stage],
}));

export interface ProjectColumn {
  /** Group name from `statusOptions` ("Workflow" | "On Hold" | "Closed"). */
  id: string;
  /** Display label (same as id). */
  label: string;
  /** All `projects.status` values that map to this column. */
  statuses: string[];
}

export const PROJECT_COLUMNS: ProjectColumn[] = statusOptions.map((group) => ({
  id: group.group,
  label: group.group,
  statuses: group.options,
}));

/** Lookup: project status string -> column id. */
export const PROJECT_STATUS_TO_COLUMN: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const col of PROJECT_COLUMNS) {
    for (const status of col.statuses) {
      map[status] = col.id;
    }
  }
  return map;
})();
